import { useRef, useEffect } from "react";
import { CFormInput , CCardBody,CCol,CRow, CButton } from '@coreui/react';
import { useState } from "react";

const AutoComplete = ({initialValue='',AddFacilityFn}) => {
 const autoCompleteRef = useRef();
 const inputRef = useRef();
 const newFacility = useRef({})
 const [searchValue,setSearchValue] = useState(initialValue)
 const options = {
    componentRestrictions: { country: "usa" },
    fields: ["address_components", "geometry", "icon", "name"],
    types: ["establishment"]
   };
 useEffect(() => {
  autoCompleteRef.current = new window.google.maps.places.Autocomplete(
   inputRef.current,
   options
  );
  autoCompleteRef.current.addListener("place_changed", async function () {
   const place = await autoCompleteRef.current.getPlace();
   let addr = ""
   place.address_components.map(obj=>{
    if (obj["types"][0] == "postal_code_suffix") {
        return
    }
    if (addr == '') {
        addr =  obj["long_name"]    
    } else {
        addr = addr + ',' + obj["long_name"]
    }
    
   })
   newFacility.current = {Address:addr,Lat:place.geometry.location.lat(),Lng:place.geometry.location.lng(),Name:place.name}
  });
 }, []);

 const handleOnClick = (e) => {
    AddFacilityFn(newFacility.current)
 }

 const handleOnChange = (e) => {
    setSearchValue(e.target.value)
 }
 return (
<div style={{ display: 'flex', alignItems: 'center' }}>
      <CFormInput 
        value={searchValue} 
        onChange={handleOnChange} 
        ref={inputRef} 
        placeholder="Enter a location"
        style={{ 
          flex: 1, 
          marginRight: '8px'
        }}
      />
      {/* <CButton onClick={handleOnClick}>
        Add Facility
      </CButton> */}
    </div>
 );
};
export default AutoComplete;